module.exports = __webpack_public_path__ + "media/images/icons/flags/DZ-9d53cbe8604201a02742aaf0d515bb3c.svg";